import { COMMA, ENTER } from '@angular/cdk/keycodes'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormControl, FormsModule } from '@angular/forms'
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips'

import { CommonModule } from '@angular/common'
import { NgxMaskDirective } from 'ngx-mask'
import { SharedModule } from '@shared/shared.module'

@Component({
  selector: 'scope-ui-chips',
  standalone: true,
  imports: [CommonModule, FormsModule, SharedModule, NgxMaskDirective],
  templateUrl: './scope-ui-chips.component.html',
  styleUrls: ['./scope-ui-chips.component.scss'],
})
export class ScopeUiChipsComponent {
  @Input() inputLabel: string
  @Input() selectionEnabled = true
  @Input() selectedValue: any
  @Input() values: any[] = []
  @Input() control: FormControl = new FormControl([])

  @Output() valuesChange = new EventEmitter<any[]>()
  @Output() selectedValueChange = new EventEmitter<any>()

  readonly separatorKeysCodes = [ENTER, COMMA] as const

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim()

    if (value) {
      this.values.push(value)
      this.setValues()
    }

    // Clear the input value
    event.chipInput!.clear()
  }

  remove(option: string): void {
    const index = this.values.indexOf(option)

    if (option == this.selectedValue) this.select(null)

    if (index >= 0) {
      this.values.splice(index, 1)
      this.setValues()
    }
  }

  edit(option: string, event: MatChipEditedEvent) {
    // Prevents default behaviour of keeping focus on edited chip
    event.chip.disabled = true
    setTimeout(() => (event.chip.disabled = false))

    const index = this.values.indexOf(option)
    const currentValue = this.values[index]
    const newValue = event.value.trim()

    // Set new default value if current default value had been changed
    if (currentValue == this.selectedValue && currentValue != newValue) this.select(newValue)

    // Remove option if it no longer has a name
    if (!newValue) {
      this.remove(option)
      this.select(newValue)
      this.setValues()
      return
    }

    // Edit existing option
    if (index >= 0 && currentValue != newValue) {
      this.values[index] = newValue
      this.setValues()
    }
  }

  select(option: string) {
    if (this.selectionEnabled) this.selectedValueChange.emit(this.selectedValue == option ? null : option)
  }

  private setValues() {
    this.valuesChange.emit(this.values)
    this.control.setValue(this.values)
  }
}
